import React from "react";
import { NAME, EMAIL } from "../../../helpers/maxLenghts";
import useMobile from "../../../hooks/useOrientation";

const Responsible = ({ data, onChangeData }) => {
  const isMobile = useMobile();

  return (
    <div style={styles.container}>
      <div style={styles.stepHeader}>
        <h2 style={styles.stepTitle}>Datos del tutor</h2>
        <p style={styles.stepSubtitle}>
          Ingresá los datos del padre, madre o tutor responsable.
        </p>
      </div>

      <div
        style={{
          ...styles.grid,
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        }}
      >
        <Field
          label="Nombre"
          placeholder="Nombre"
          value={data.name}
          maxLength={NAME}
          onChange={(val) => onChangeData({ ...data, name: val })}
          capitalize
        />
        <Field
          label="Apellido"
          placeholder="Apellido"
          value={data.lastName}
          maxLength={NAME}
          onChange={(val) => onChangeData({ ...data, lastName: val })}
          capitalize
        />
      </div>

      <Field
        label="Email"
        placeholder="correo@ejemplo.com"
        value={data.email}
        maxLength={EMAIL}
        type="email"
        onChange={(val) => onChangeData({ ...data, email: val })}
      />
      <Field
        label="Celular"
        placeholder="09X XXX XXX"
        value={data.phone}
        maxLength={20}
        type="tel"
        onChange={(val) => onChangeData({ ...data, phone: val })}
      />
    </div>
  );
};

export default Responsible;

// ---- Shared field component ----

export const Field = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  maxLength,
  capitalize,
}) => (
  <div style={fieldStyles.group}>
    <label style={fieldStyles.label}>{label}</label>
    <input
      style={fieldStyles.input}
      type={type}
      placeholder={placeholder}
      value={value || ""}
      maxLength={maxLength}
      onChange={(e) => onChange(e.target.value)}
      autoComplete="off"
      onFocus={(e) => (e.target.style.borderColor = "#00D2B7")}
      onBlur={(e) => (e.target.style.borderColor = "#e0e0e0")}
    />
  </div>
);

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  stepHeader: {
    marginBottom: 20,
  },
  stepTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#111",
    fontFamily: "Gilroy-Bold",
    marginBottom: 4,
  },
  stepSubtitle: {
    fontSize: 15,
    color: "#888",
  },
  grid: {
    display: "grid",
    gap: 4,
  },
};

export const fieldStyles = {
  group: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    marginBottom: 14,
  },
  label: {
    fontSize: 14,
    color: "#888",
    fontWeight: 500,
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    border: "1.5px solid #e0e0e0",
    borderRadius: 8,
    fontSize: 16,
    color: "#111",
    background: "#fff",
    outline: "none",
    fontFamily: "Gilroy",
    boxSizing: "border-box",
    transition: "border-color 0.15s",
  },
};
